// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/**
 * This class is bind the enviroment values
 * @export
 */
export const environment = {
  production: false,
  URL_BASE: "https://passwordresetcore.beesuite.app",
  URL_API: "https://passwordresetcore.beesuite.app",
  URL_EUSR: "https://a.beesuite.app/",
  URL_ACTIVATION: "https://appcore.beesuite.app",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
